<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.activities_index,
                    },
                    {
                        name: $t('messages.practice'),
                        href: meta.links.practice_index,
                    },
                ]"
            />
        </template>

        <PracticeRace :practice-race="practiceRace" :factions="factions" />

        <div class="mt-5 flex flex-wrap gap-2">
            <BadgePill v-for="tag in meta.info.tags" :key="tag.id">
                {{ tag.name }}
            </BadgePill>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import PracticeRace from '@/Pages/Teacher/Gamification/Groups/PracticeRace/partials/PracticeRace.vue';
import BadgePill from '@/components/BadgePill.vue';

export default {
    components: {
        BadgePill,
        PracticeRace,
        PanelPage,
    },
    layout: Layout,
    name: 'Show',
    props: ['practiceRace', 'meta', 'factions', 'group'],
};
</script>
